export default __webpack_public_path__ + "static/bbc-111467e2cac69f61d46e16f95192420b.svg";